import React from "react";
import { Card } from "react-bootstrap";

function HomeInfo() {
  return (
    // <Container fluid>
    <Card className="border-0 my-5">
      <Card.Body className="px-0">
        <blockquote className="blockquote p-0 m-0">
          <p
            className="h1 font-size-sm color-primary fst-italic"
            id="quote"
            style={{
              color: "#d9001b",  
                   
            }}
          >
            “Give wings and feet to the Gospel, that it may travel far and
            wide.”
          </p>
        </blockquote>
        <figcaption className="blockquote-footer pt-3 fs-4" id="quote-author">
          Venerable Sr Thecla Merlo <cite title="Source Title"></cite>
        </figcaption>
      </Card.Body>
    </Card>
    // </Container>
  );
}

export default HomeInfo;
